// extracted by mini-css-extract-plugin
module.exports = {"root":"loading_root__Xyfz2","loader":"loading_loader__-gUqG","spinner":"loading_spinner__15aiZ","title":"loading_title__3NimZ","description":"loading_description__21lJs"};